module.exports = __webpack_public_path__ + "static/media/CampainManagement.91f7ee41.svg";